import { render } from "./list-landing-page.vue?vue&type=template&id=c84f1cb6&scoped=true"
import script from "./list-landing-page.vue?vue&type=script&lang=js"
export * from "./list-landing-page.vue?vue&type=script&lang=js"

import "./list-landing-page.vue?vue&type=style&index=0&id=c84f1cb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84f1cb6"]])

export default __exports__